module.exports = __webpack_public_path__ + "shapes-big.png?f7cdaf555fe524a70c42ac90fb804b49";